import { css } from '@emotion/react';

export const container = css`
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 gap: 10px;
 width: 100%;
`;

export const content = css`
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 gap: 4px;
 
 text-align: center;
 width: inherit;
`;
